const state = {
  metaInfo: {
    title: "",
    keywords: "",
    description: "",
  },
};
const mutations = {
  CHANGE_META_INFO(state, metaInfo) {
    state.metaInfo = metaInfo;
  },
};
const actions = {
  changeMetaInfo({ commit }, view) {
    let { title, keywords, description } = view;
    let metaData = {
      title: title ? title : process.env.VUE_APP_NAME,
      keywords: keywords ? keywords : "椒椒我,椒椒我官网,miyustar",
      description: description
        ? description
        : "一款主打“自由、随心”聊天交友的软件平台，高颜值的人都在用，能快速满足“同城处CP、陌生人交朋友”的社交娱乐需求。",
    };
    commit("CHANGE_META_INFO", metaData);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
